<template>
  <div id="form-view">
    <input
      id="user-id"
      type="hidden"
      v-model="view.usuario"
    />
    <input
      id="view-id"
      type="hidden"
      v-model="view.id"
    />
    <v-row>
      <v-col
        md="4"
        sm="6"
      >
        <v-autocomplete
          v-model="view.uid_grupo"
          :items="parent"
          outlined
          dense
          label="Grupo de menus:"
          @change="loadMenus()"
        >
          <v-btn
            class="btn-outer pa-0"
            slot="append"
            color="success"
            tile
          >
            <v-icon
              class="mx-0"
              color="white"
            >
              mdi-magnify
            </v-icon>
          </v-btn>
          <v-btn
            class="btn-outer-right pa-0"
            slot="append"
            color="light"
            tile
          >
            <v-icon
              class="mx-0"
              color="black"
            >
              mdi-plus
            </v-icon>
          </v-btn>
        </v-autocomplete>
      </v-col>
      <v-col
        md="4"
        sm="6"
      >
        <v-autocomplete
          v-model="view.uid_menu"
          :items="menus"
          outlined
          dense
          label="Menu do sistema:"
          @change="loadMenuId()"
        >
          <v-btn
            class="btn-outer pa-0"
            slot="append"
            color="success"
            tile
          >
            <v-icon
              class="mx-0"
              color="white"
            >
              mdi-magnify
            </v-icon>
          </v-btn>
          <v-btn
            class="btn-outer-right pa-0"
            slot="append"
            color="light"
            tile
          >
            <v-icon
              class="mx-0"
              color="black"
            >
              mdi-plus
            </v-icon>
          </v-btn>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="view.view"
          label="nome do módulo"
          outlined
          required
          dense
          hint="Por exemplo, viewPage"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-card-text class="py-0 mt-0">Nome da view:<h4>{{ dsView }}</h4>
        </v-card-text>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'FormView',
  props: {
    dsView: { type: String, default: null },
    view: { default: null },
    path: {},
    parent: [],
    menus: []
  },
  data: () => ({

  }),
  methods: {
    loadMenus () {
      const uid = this.view.uid_grupo
      this.$emit('load-menus', uid)
    },
    loadMenuId () {
      this.$emit('load-menu-id')
    }
  }
}
</script>
<style scoped>
.btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
}
.btn-outer-right {
  margin-top: -7px !important;
  margin-right: -11px !important;
}
.v-size--default {
  height: 37px !important;
  min-width: 38px !important;
}
</style>
